import { Component, OnInit} from "@angular/core";

@Component({
  selector: 'openpay-settings-header-component',
  templateUrl: './settings-header.component.html',
  styleUrls: ['./settings-header.component.scss']
})

export class SettingsHeaderComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
